import { defineComponent, ref } from "vue";
import BaseDialog from "./component-library278.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "flyout",
  props: {
    customClass: { default: void 0 },
    dataTealiumRel: { default: void 0 },
    headingText: { default: void 0 },
    ariaLabel: { default: void 0 },
    closeOnBackdrop: { type: Boolean, default: true },
    disableFocusTrap: { type: Boolean },
    closeAutofocus: { type: Boolean },
    success: { type: Boolean },
    error: { type: Boolean },
    warning: { type: Boolean }
  },
  emits: ["onCloseModal"],
  setup(__props, { expose }) {
    const baseDialog = ref(null);
    const openDialog = () => {
      var _a;
      return (_a = baseDialog.value) == null ? void 0 : _a.openDialog();
    };
    expose({
      openDialog,
      closeDialog: () => {
        var _a;
        return (_a = baseDialog.value) == null ? void 0 : _a.closeDialog();
      }
    });
    return { __sfc: true, baseDialog, openDialog, BaseDialog };
  }
});
export {
  _sfc_main as default
};
